import { Component, inject, OnInit, Type } from '@angular/core';
import { HeaderComponent } from '../../common-components/header/header.component';
import { SettingsOptionComponent } from './components/settings-option/settings-option.component';
import { SettingsService } from '../../services/settings.service';
import { PopupComponent } from '../../common-components/popups/popup/popup.component';
import { AppSettings } from '../../interfaces/app-settings.interface';
import { SettingOption } from '../../interfaces/settings-option.interface';
import { SettingsPopupComponent } from '../../common-components/popups/settings-popup/settings-popup.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-settings-page',
  standalone: true,
  imports: [
    HeaderComponent,
    SettingsOptionComponent,
    PopupComponent,
    TranslocoPipe
  ],
  templateUrl: './settings-page.component.html',
  styleUrl: './settings-page.component.scss'
})
export class SettingsPageComponent implements OnInit {

  protected dynamicComponent: Type<any> = Object;
  protected isOpen: boolean = false;
  protected popupData: any;
  protected slideInFrom = 'translateY(100%)';
  protected currentSettings!: AppSettings;
  protected currenSettingKeys : (keyof AppSettings)[] = [];
  protected readonly SettingsPopupComponent = SettingsPopupComponent;

  private settingsService = inject(SettingsService);


  ngOnInit(): void {
    this.currentSettings = this.settingsService.currentSettings;
    this.currenSettingKeys = Object.keys(this.currentSettings) as (keyof AppSettings)[];
  }

  protected initPopup<T>(option: SettingOption<T>) {
    this.popupData = option;
    this.openPopup();
  }


  protected openPopup() {
    this.isOpen = !this.isOpen;
  }
}
